/* Canonical origin and the one social preview image. index.html carries the
   same values literally (crawlers don't run JS); keep them in step.
   The card's source is scripts/social-card/card.html. When it changes,
   render to a new filename: link previews are cached by image URL. */
export const SITE_ORIGIN = 'https://factory-os.com';
export const SOCIAL_IMAGE = `${SITE_ORIGIN}/og/factory-os-2026-09.png`;
